import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header style={{ marginTop: "8px" }}>
      <Link to="/" className="logo">
        <img
          src="/images/khasdar.svg"
          alt="KSM Logo"
          style={{ height: "100px" }}
        />
      </Link>

      <div className="right-icons">
        <div className="top-row-icons">

          {/* 1. SOCIAL ICONS: Hide when isMenuOpen is true */}
          <ul
            className="sci"
            style={{ display: isMenuOpen ? 'none' : 'flex' }}
          >
            <li>
              <a
                href="https://www.facebook.com/KhasdarMahotsavNagpur"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-facebook"></i>
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/@KhasdarMahotsavNagpur"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-youtube-play"></i>
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/khasdarmahotsavnagpur/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-instagram"></i>
              </a>
            </li>
          </ul>

          {/* 2. HAMBURGER ICON: Hide when isMenuOpen is true */}
          <div
            className="hamburger"
            id="hamburger"
            onClick={toggleMenu}
            style={{ display: isMenuOpen ? 'none' : 'block' }}
          >
            <i className="fa fa-bars" aria-hidden="true"></i>
          </div>

        </div>
      </div>

      {/* SIDE MENU: Class is set using the isMenuOpen state */}
      <div className={`side-menu ${isMenuOpen ? "active" : ""}`} id="sideMenu">
        <div className="close-btn" id="closeMenu" onClick={closeMenu}>
          <i className="fa fa-times-circle" aria-hidden="true"></i>
        </div>
        <ul>
          <li>
            <Link to="/" onClick={closeMenu}>
              <i className="fa fa-home" aria-hidden="true"></i>
              <span>Home</span>
            </Link>
          </li>
          <li>
            <Link to="/about-ksm" onClick={closeMenu}>
              <i className="fa fa-info-circle" aria-hidden="true"></i>
              <span>About KSM</span>
            </Link>
          </li>
          <li>
            <Link to="/about-khasdar-mahotsav" onClick={closeMenu}>
              <i className="fa fa-calendar" aria-hidden="true"></i>
              <span>About Khasdar Mahotsav</span>
            </Link>
          </li>
          <li>
            <a
              href="/commitee.png"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              <i className="fa fa-users" aria-hidden="true"></i>
              <span>Committee Members</span>
            </a>
          </li>
          <li>
            <a href="/terms" onClick={closeMenu}>
              <i className="fa fa-file-text" aria-hidden="true"></i>
              <span>Terms & Conditions</span>
            </a>
          </li>
          <li>
            <a href="/privacy-policy" onClick={closeMenu}>
              <i className="fa fa-shield" aria-hidden="true"></i>
              <span>Privacy Policy</span>
            </a>
          </li>
          <li>
            <a href="/contact" onClick={closeMenu}>
              <i className="fa fa-envelope" aria-hidden="true"></i>
              <span>Contact Us</span>
            </a>
          </li>


          <li>
            <a href="/faq" onClick={closeMenu}>
              <i className="fa fa-question-circle" aria-hidden="true"></i>
              <span>FAQs</span>
            </a>
          </li>
          <li>
            <a
              href="https://pruthvi.bharatonline.digital/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              <img
                src="/bo_logo.png"
                alt="Pruthvi Map"
                className="menu-icon-img"
              />
              <span>Pruthvi Map</span>
            </a>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;